import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function getAllCountry(search?:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETCOUNTRY}?search=${search || ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addCountry(payload:any) {

  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.ADDCOUNTRY, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getParentHierarchy(level:any,isDepartment:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETPARENTHIERARCHY + `?level=${level}&isDepartment=${isDepartment}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getAllState(search?:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETSTATE}?search=${search || ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function addState(payload:any) {

  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.ADDSTATE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function addCity(payload:any) {

  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.ADDCITY, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllCity(search?:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETCITY}?search=${search || ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addLocationMeta(payload:any) {

  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.ADDLOCATIONMETA, callParams);
    return response;
  } catch (error) {
     console.warn(error)
  }
}
export async function getLocationMeta(search?:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETLOCATIONMETA}?search=${search || ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getLocationById(id?:any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETLOCATIONMETA}${id}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}